// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MakeRosterQuest_wrapper_3XpwL","logo":"MakeRosterQuest_logo_2zcLL","container":"MakeRosterQuest_container_BI1xU"};